import createIcon from '../../createIcon';

/**
 * @component @name PhonelinkRing
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuMTEyNyA3LjdMMTkuMTEyNyA4LjdDMjAuOTEyNyAxMC41IDIwLjkxMjcgMTMuMyAxOS4xMTI3IDE1LjJMMjAuMTEyNyAxNi4yQzIyLjYxMjcgMTMuOSAyMi42MTI3IDEwLjEgMjAuMTEyNyA3LjdaTTE4LjAxMjcgOS44TDE3LjAxMjcgMTAuOEMxNy41MTI3IDExLjUgMTcuNTEyNyAxMi40IDE3LjAxMjcgMTMuMUwxOC4wMTI3IDE0LjFDMTkuMjEyNyAxMi45IDE5LjIxMjcgMTEuMSAxOC4wMTI3IDkuOFpNMTQuMDEyNyAxSDQuMDEyN0MyLjkxMjcgMSAyLjAxMjcgMS45IDIuMDEyNyAzVjIxQzIuMDEyNyAyMi4xIDIuOTEyNyAyMyA0LjAxMjcgMjNIMTQuMDEyN0MxNS4xMTI3IDIzIDE2LjAxMjcgMjIuMSAxNi4wMTI3IDIxVjNDMTYuMDEyNyAxLjkgMTUuMTEyNyAxIDE0LjAxMjcgMVpNMTQuMDEyNyAyMEg0LjAxMjdWNEgxNC4wMTI3VjIwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PhonelinkRing = createIcon('PhonelinkRing', [
  [
    'path',
    {
      d: 'M20.1127 7.7L19.1127 8.7C20.9127 10.5 20.9127 13.3 19.1127 15.2L20.1127 16.2C22.6127 13.9 22.6127 10.1 20.1127 7.7ZM18.0127 9.8L17.0127 10.8C17.5127 11.5 17.5127 12.4 17.0127 13.1L18.0127 14.1C19.2127 12.9 19.2127 11.1 18.0127 9.8ZM14.0127 1H4.0127C2.9127 1 2.0127 1.9 2.0127 3V21C2.0127 22.1 2.9127 23 4.0127 23H14.0127C15.1127 23 16.0127 22.1 16.0127 21V3C16.0127 1.9 15.1127 1 14.0127 1ZM14.0127 20H4.0127V4H14.0127V20Z',
      key: '13qro5',
    },
  ],
]);

export default PhonelinkRing;
